<template>
    <section>
        <div>
            
            <div class="t-body3 mgt-6 t-color-content1">
                {{$t('376')}}
                <!-- 비밀번호 재설정를 위한 코드를 받을 방법을 선택하세요. -->
            </div>
            <!-- {{findPw.authMethods[0].findWay}}
            {{findPw.authMethods[0].value}}
            {{findPw.authMethods[1]?findPw.authMethods[1].findWay?findPw.authMethods[1].findWay.value:'':''}}
            {{findPw.authMethods[1].value}} -->
            <div class="mgt-8">
                <!-- <div class="mgt-30">
                    <div class="mdc-form-field">
                        <div class="mdc-radio radio-red">
                            <input class="mdc-radio__native-control" type="radio" 
                                name="findType"
                                id="findTypeSMS"
                                :value="sms"
                                v-model="findType"
                                @click="setValue(findPw.authMethods[1]?findPw.authMethods[1].value:'')"
                                >
                            <div class="mdc-radio__background">
                                <div class="mdc-radio__outer-circle"></div>
                                <div class="mdc-radio__inner-circle"></div>
                            </div>
                        </div>
                        <label  class="t-body1">
                            {{$t('33')}}
                        </label>
                        
                    </div>
                    
                </div> -->

                <div class="mgt-30">
                    <div class="mdc-form-field">
                        <div class="mdc-radio radio-red">
                            <input class="mdc-radio__native-control" type="radio" 
                                name="findType"
                                id="findTypeEMAIL"
                                :value="email"
                                v-model="findType"
                                @click="setValue(findPw.authMethods[0]?findPw.authMethods[0].value:'')"
                                >
                            <div class="mdc-radio__background">
                                <div class="mdc-radio__outer-circle"></div>
                                <div class="mdc-radio__inner-circle"></div>
                            </div>
                        </div>
                        <label  class="t-body1">
                            {{$t('34')}}
                        </label>
                        
                    </div>
                    
                </div>

            </div>
            <div class="mgt-38">
                <button class="mdc-button mdc-button--raised btn-red" @click="getCertiNumber()">
                    {{$t('381')}}
                    <!-- 코드 받기 -->
                </button>
                <button class="mdc-button btn-white mgr-8 mgl-8" @click="cancelFindPw()" type="button">
                    {{$t('382')}}
                    <!-- 취소 -->
                </button>
                
                
            </div>
        </div>
    </section>
    
</template>

<script>
/**
 * 비밀번호 재설정 Step2 컴포넌트 (reset password Step2 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'
import {findIdMixin} from '@/mixins/findId.js'
export default {
    data() {
        return {
            findType: '',
            value: '',
            sms:'SMS',
            email:'EMAIL'
        }
    },

    mixins: [findIdMixin],

    computed: {
        ...mapState('findPw',{
            findPw : state => state,
        })
    },

    mounted() {
        // 인증 수단이 없을 경우 Step1로 이동(If there is no authentication method, go to Step1)
        if (!this.findPw.authMethods.length) {
            this.$moveLogin()
        }
        this.setMaterialUi()
                
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('findPw', ['SET_STEP2','SET_STEP3']),

        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        // 인증수단 설정(Authentication method setting)
        setValue(value) {
            console.log('value',value)
            this.value = value
        },
        
        // 인증번호 발송 API 호출(Authentication number sending API call)
        getCertiNumber() {
            if (!this.findType || !this.value){
                // this.$snackOpen({contents:'비밀번호 재설정위한 코드를 받을 방법을 선택하세요.'}).then(() => {})
                this.$snackOpen({
                    contents: this.$t('955'), //비밀번호 재설정을 위한 코드를 받을 방법을 선택하세요.
                    btnDisplayYN: false
                    //btnDisplay: this.$t('Common.00001')
                }).then(() => {})
                return
            }

            let params = {
                findWay: this.findType,
                value: this.value
            }

            this.SET_STEP2(params)

            let responseData = null
            findApi.requestFindPw(params).then((response) => {
                responseData = response.data.data
                // console.log(responseData.token)
                this.SET_STEP3({
                    value: this.value,
                    token: responseData.token
                })

                this.$router.push({
                    name: 'FindPwStep3'
                })
            }).catch((err) => {
                responseData = err.response.data.meta
                this.$error({content: responseData.errMsg}).then(() => {})
                
            })
        },
    },
}
</script>